import {BasePanel} from "./BasePanel";
import {iFrameState} from "../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../blink-sdk/Constants";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw";


@autoredraw(iFrameState)
export class FunctionalityNotEnabledPanel extends BasePanel {
    getMessage() {
        switch(iFrameState.panelType) {
            case PANEL_TYPE.newsletter: return Messages.functionalityNotEnabledNewsletters;
            case PANEL_TYPE.subscribe: return Messages.functionalityNotEnabledSubscriptions;
            case PANEL_TYPE.donation: return Messages.functionalityNotEnabledDonations;
            case PANEL_TYPE.donationPage: return Messages.functionalityNotEnabledDonations;
            default: return Messages.functionalityNotEnabledGeneric;
        }
    }

    render() {
        return <MessageElement message={this.getMessage()} args={[iFrameMerchantService.getMerchant().name]}/>;
    }
}
